import styled from "styled-components";

export const Wrapper = styled.div<{ $visibleItems: number }>`
  display: flex;
  flex: 1;
  width: 100%;
  height: 100%;
  min-height: 0;
  gap: ${({ theme }) => theme.spacing.small};
  --step-scroll-gap: ${({ theme }) => theme.spacing.medium};
  --step-scroll-visible-items: ${({ $visibleItems }) => $visibleItems};

  @media screen and (max-width: 1100px) {
    height: auto;
  }
`;

export const ScrollArea = styled.div`
  position: relative;
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: var(--step-scroll-gap);
  overflow-y: auto;
  scroll-snap-type: y mandatory;
  /* Графики меняют высоту после загрузки — без этого браузер «якорит»
     прокрутку и список остаётся сдвинутым. */
  overflow-anchor: none;

  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
  }

  @media screen and (max-width: 1100px) {
    height: auto;
    overflow-y: visible;
    scroll-snap-type: none;
  }
`;

export const Item = styled.div<{ $center?: boolean }>`
  display: flex;
  flex-shrink: 0;
  min-height: 0;
  height: calc(
    (
        100% - (var(--step-scroll-visible-items) - 1) *
          var(--step-scroll-gap)
      ) / var(--step-scroll-visible-items)
  );
  scroll-snap-align: ${({ $center }) => ($center ? "center" : "start")};

  > * {
    min-height: 0;
  }

  @media screen and (max-width: 1100px) {
    height: auto;
  }
`;

export const Spacer = styled.div`
  flex-shrink: 0;
  width: 100%;
  pointer-events: none;

  @media screen and (max-width: 1100px) {
    display: none;
  }
`;

export const Dots = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 20px;
  padding: 16px 0;
  border-radius: 999px;

  @media screen and (max-width: 1100px) {
    display: none;
  }
`;

export const Dot = styled.button<{ $active: boolean }>`
  width: ${({ $active }) => ($active ? "12px" : "8px")};
  height: ${({ $active }) => ($active ? "12px" : "8px")};
  padding: 0;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  background: ${({ theme, $active }) =>
    $active ? theme.colors.stepDot : theme.colors.scrollbar};
  transition: width 0.2s ease, height 0.2s ease, background 0.2s ease;

  &:hover {
    background: ${({ theme, $active }) =>
      $active ? theme.colors.stepDot : theme.colors.scrollbarHover};

    background: ${({ theme, $active }) =>
      $active ? theme.colors.stepDot : theme.colors.scrollbarHover};
  }
`;
